<template>
  <svg viewBox="0 0 64 64">
    <svg>
      <svg id="prijs">
        <path
          d="M31.8,29.2c-2.1-0.4-4.2-0.1-6.3,1.2l-1.3-1.3l-2,1v0.1l1.5,1.6c-0.1,0.1-0.3,0.2-0.4,0.4
                        c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.4l-1-1.1l-2.1,1.1v0.1l1.8,1.9
                        c-1.2,2.1-1.6,4.4-1.3,6.5c0.3,2.1,1.3,4.2,2.8,5.8c1.1,1.1,2.4,2.1,4,2.8l1.5-1.6l0-0.1c-1.5-0.6-2.8-1.5-3.8-2.5
                        c-1.2-1.2-1.9-2.7-2.2-4.3c-0.3-1.5-0.1-3.2,0.6-4.8l5.2,5.5l2-1l0.1-0.2l-6-6.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3
                        c0.2-0.3,0.5-0.5,0.8-0.7l6.5,7l2-1v-0.1l-6.7-7.2c1.5-0.8,3-1,4.5-0.6c1.5,0.3,2.9,1.2,4.1,2.6c0.8,0.9,1.5,1.8,2.1,3.1l2-1
                        c-0.6-1.4-1.6-2.6-2.4-3.5C35.8,30.8,33.8,29.6,31.8,29.2"
        />
        <path
          d="M54,30.1L24.6,61.5L4.8,40.3L34.2,9l18.4,0.4l-7.8,8.3c-0.8-0.3-1.8-0.1-2.5,0.6c-0.9,1-0.9,2.6,0,3.6
                        c0.9,1,2.4,1,3.4,0c0.8-0.8,0.9-2.1,0.3-3.1l7.7-8.2L54,30.1z M62.4,1.2L61.2,0l-7.2,7.7L33.5,7.3l-31,33l22,23.5l31-33L55.2,8.9
                        L62.4,1.2z"
        />
      </svg>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconPrijs extends Vue {}
</script>
